import React from 'react';

import { Typography } from '@material-ui/core';

import { COLORS } from 'theme/constants';
import { CATEGORY_NAMES, METRIC_EVENT_NAMES } from 'metrics/constants';
import { LINKS } from 'components/constants';
import { useMatomo } from 'contexts/MatomoContext';

import { Box, BuilderFormLink } from '../style';

export const BuilderContactUsFooter = () => {
  const { trackEvent } = useMatomo();

  const handleClick = () => {
    trackEvent({
      category: CATEGORY_NAMES.PUBTOOL_EVENTS,
      action: 'click',
      name: METRIC_EVENT_NAMES.CONTACT_US,
    });
    window.open(`mailto:${LINKS.contactEmail}`, '_blank');
  };

  return (
    <Box mt="auto" justifyContent="center">
      <Typography variant="caption" style={{ color: COLORS.builderSubTitleColor }}>
        Having trouble?&nbsp;
      </Typography>
      <BuilderFormLink
        text="Contact Support"
        variant="text"
        style={{ color: COLORS.builderBrandColor, textDecoration: 'none' }}
        onClick={handleClick}
      />
    </Box>
  );
};
